import React, { createRef } from 'react';
import { imageWithPrefix } from '../../scripts/helpers';
import { breakpoints, placeholder } from '../../scripts/media';
import { ISources, IImage } from '../../interfaces/generic';
export type PictureProps = {
  lazyLoading?: any;
  id?: string;
  className?: string;
  image: IImage;
  sources: ISources[];
  placeholder?: string;
};

class Picture extends React.Component<PictureProps> {
  private placeholderRef: any;
  constructor(props: PictureProps) {
    super(props);

    if (this.props.lazyLoading) {
      this.placeholderRef = createRef();
    }
  }
  componentDidMount() {
    if (this.props.lazyLoading) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              const images = entry.target.childNodes;
              images.forEach((img: any, i) => {
                if (img.nodeName === 'IMG') {
                  img.src = imageWithPrefix(this.props.image.src);
                }
                if (img.nodeName === 'SOURCE') {
                  img.srcset = img.dataset.srcset;
                  delete img.dataset.srcset;
                }
              });
              obs.disconnect();
            }
          }
        },
        {
          rootMargin: '100px',
          threshold: 0,
        },
      );
      observer.observe(this.placeholderRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }
  formImageProps() {
    const imageProps: any = {};
    imageProps.src = this.props.lazyLoading
      ? this.props.placeholder || placeholder
      : imageWithPrefix(this.props.image.src);
    imageProps.width = this.props.image.width || '320'; // default mobile width
    if (this.props.image.height) {
      imageProps.height = this.props.image.height;
    }
    if (this.props.image.className) {
      imageProps.className = this.props.image.className;
    }
    imageProps.alt = this.props.image.alt || '';

    return imageProps;
  }
  formSourceProps(source: ISources) {
    const newS: any = Object.assign({}, source);
    if (newS.media) {
      newS.media = `(min-width:${breakpoints[source.media]}px)`;
    }
    if (newS.srcSet) {
      const src = imageWithPrefix(newS.srcSet);
      if (this.props.lazyLoading) {
        newS['data-srcset'] = src;
        newS.srcSet = this.props.placeholder || placeholder;
        // delete newS.srcSet;
      } else {
        newS.srcSet = src;
      }
    }
    return newS;
  }
  render() {
    const returnCl = () => {
      return this.props.className ? { className: this.props.className } : {};
    };
    return (
      <picture
        {...returnCl()}
        ref={this.placeholderRef}>
        {this.props.sources.map((source, i) => (
          <source
            key={i}
            {...this.formSourceProps(source)}
          />
        ))}
        <img {...this.formImageProps()} />
      </picture>
    );
  }
}

export default Picture;
